import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';
import { devMode } from '@/utils';

let analytics = null;
const clientCredentials = {
  apiKey: 'AIzaSyCS5aNRn1rfok-kYbaZvk6AXgG9NS1ACns',
  authDomain: 'decooj-9daae.firebaseapp.com',
  projectId: 'decooj-9daae',
  storageBucket: 'decooj-9daae.appspot.com',
  messagingSenderId: '363277564831',
  appId: '1:363277564831:web:f7a4b9bc04b246d2fcdbaa',
  measurementId: 'G-8ZXYJB183Y',
};

const apps = getApps();
if (!apps.length) {
  // Initialize Firebase
  const app = initializeApp(clientCredentials);
  // Check that `window` is in scope for the analytics module!
  if (typeof window !== 'undefined' && !devMode) {
    getPerformance(app);
    analytics = getAnalytics(app);
  }
}

export const logScreenView = (url) => {
  if (!analytics) return;
  logEvent(analytics, 'screen_view', {
    firebase_screen: url,
  });
};
